import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ProducerActivityItem {
  id: string;
  producer_id: string;
  source: string;
  type: string;
  level: string;
  title: string;
  message: string;
  actor_user_id: string | null;
  created_at: string;
  event_code: string | null;
}

export function useProducerActivityLog(producerId: string | undefined, limit: number = 10) {
  return useQuery({
    queryKey: ['producer-activity-log', producerId, limit],
    queryFn: async (): Promise<ProducerActivityItem[]> => {
      if (!producerId) return [];

      const { data, error } = await (supabase as any)
        .rpc('get_producer_activity_log_v1', {
          p_producer_id: producerId,
          p_limit: limit,
        });

      if (error) {
        console.error('[useProducerActivityLog] query error:', error.message);
        return [];
      }

      return (data ?? []) as unknown as ProducerActivityItem[];
    },
    enabled: !!producerId,
  });
}
